import React from 'react';
import Warning from '../../common/Warning';
import ExpandableContainer from './ExpandableContainer';
import StepHorizontalField from './StepHorizontalField';
import StepHorizontalDoubleField from './StepHorizontalDoubleField';
import StepHorizontalDoubleFieldItem from './StepHorizontalDoubleFieldItem';
import { Configuration } from "../../../../src/application/Contracts";

function RightSideUnderExchangerSides() {
    return null
}

function LeftSideUnderExchangerSides() {
    return null
}

export default class HeatExchangerRequirements extends React.Component {

    static RightSideUnderExchangerSides = RightSideUnderExchangerSides

    static LeftSideUnderExchangerSides = LeftSideUnderExchangerSides

    render() {
        const { model, renderField, children } = this.props;
        const rightSideUnderExchangerSides = React.Children.toArray(children).find(child => child.type === RightSideUnderExchangerSides)
        const leftSideUnderExchangerSides = React.Children.toArray(children).find(child => child.type === LeftSideUnderExchangerSides)

        let warnings = [
            model.primary.inletTemperature.warning,
            this.props.primary.fluid.warning,
            this.props.primary.flow.warning,
            this.props.primary.maxPressureDrop.warning,
            model.primary.outletTemperature.warning,
            model.secondary.inletTemperature.warning,
            this.props.secondary.fluid.warning,
            this.props.secondary.flow.warning,
            this.props.secondary.maxPressureDrop.warning,
            model.secondary.outletTemperature.warning,
            model.plateType.warning,
            model.numberOfPlates.warning
        ];

        if (model.heatExchangerName) { //TODO. This was created to TWS but in my opinion, should be a new component instead of trying to reuse that. We will see.
            warnings.push(model.heatExchangerName.warning)
        }

        return (
            <ExpandableContainer warnings={warnings} label={__('Heat exchanger requirements')} initialOpen={true}>
                <div className="row row-no-outer-gutter">
                    <div className="column-6 column-xs-12">
                        <div className="configuration-editor-heating-exch-background-left">
                            <div className="arrow"></div>
                            <div className="box1">
                                <div className="box3"></div>
                                <div className="box2"></div>
                            </div>

                            <div className="configuration-editor-heating-exch-content">
                                <StepHorizontalField label={model.primary.inletTemperature.label}>
                                    <div className="field-input-with-unit-container">
                                        <span
                                            className="input">{renderField(this.props.primary.inletTemperature)}</span>
                                        <span className="unit">{model.primary.inletTemperature.unit}</span>
                                    </div>
                                </StepHorizontalField>
                                {this.renderHeatExchangerRequirementsColumn(this.props.primary)}
                                <StepHorizontalField label={model.primary.outletTemperature.label}>
                                    <div className="field-input-with-unit-container">
                                        <span
                                            className="input">{renderField(this.props.primary.outletTemperature)}</span>
                                        <span className="unit">{model.primary.outletTemperature.unit}</span>
                                    </div>
                                </StepHorizontalField>
                            </div>
                        </div>
                    </div>

                    <div className="column-6 column-xs-12">
                        <div className="configuration-editor-heating-exch-background-right">
                            <div className="arrow"></div>
                            <div className="box1">
                                <div className="box3"></div>
                                <div className="box2"></div>
                            </div>

                            <div className="configuration-editor-heating-exch-content">
                                <StepHorizontalField label={model.secondary.outletTemperature.label}>
                                    <div className="field-input-with-unit-container">
                                        <span
                                            className="input">{renderField(this.props.secondary.outletTemperature)}</span>
                                        <span className="unit">{model.secondary.outletTemperature.unit}</span>
                                    </div>
                                </StepHorizontalField>
                                {this.renderHeatExchangerRequirementsColumn(this.props.secondary, true)}
                                <StepHorizontalField label={model.secondary.inletTemperature.label}>
                                    <div className="field-input-with-unit-container">
                                        <span
                                            className="input">{renderField(this.props.secondary.inletTemperature)}</span>
                                        <span className="unit">{model.secondary.inletTemperature.unit}</span>
                                    </div>
                                </StepHorizontalField>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ width: '100%', height: '20px' }}></div>

                <div className="row row-no-outer-gutter">
                    <div className="column-6 column-xs-12">
                        {this.renderStepHorizontalField(model.plateType.label, this.props.plateType, renderField, false)}
                        {model.numberOfPlates.items.filter(x => x.value !== null).length > 0 && this.renderStepHorizontalField(model.numberOfPlates.label, this.props.numberOfPlates, renderField, false)}
                        {leftSideUnderExchangerSides ? leftSideUnderExchangerSides.props.children : null}
                    </div>
                    <div className="column-6 column-xs-12">
                        {this.props.margin && this.props.margin.visible ? (
                            <StepHorizontalField label={model.margin.label} className="margin-field"
                                unit={model.margin.unit}>
                                <div className="field-input-with-unit-container">
                                    <span className="input">{renderField(this.props.margin)}</span>
                                    <span className="input-lock">{renderField(this.props.marginLock, {
                                        renderLabel: false,
                                        title: model.marginLock.label
                                    })}</span>
                                </div>
                            </StepHorizontalField>) : (<React.Fragment></React.Fragment>)
                        }
                        {(model.heatExchangerName && !model.heatExchangerName.warning) ? ( //TODO. TWS
                            <StepHorizontalField label={__('Model')} style={{ height: 38 }}>
                                <div className="field-input-with-unit-container">
                                    <span className="input">{model.heatExchangerName.value}</span>
                                    {model.preHeaterPressureDrop && model.preHeaterPressureDrop.warning &&
                                        <Warning warning={model.preHeaterPressureDrop.warning} />}
                                </div>
                            </StepHorizontalField>
                        ) : model.heatExchangerName && ( //TODO. TWS
                            <StepHorizontalField className="heat-exchanger-not-chosen" label={__('Model')}
                                style={{ height: 38 }}>
                                <span className="input-warning">{__('Exchanger not chosen')}</span>
                                <span className="warning">
                                    <div className="configuration-editor-input-wrapper">
                                        <span className="input-warning-tooltip">
                                            <Warning warning={model.heatExchangerName.warning} />
                                        </span>
                                    </div>
                                </span>
                            </StepHorizontalField>
                        )}
                        {rightSideUnderExchangerSides ? rightSideUnderExchangerSides.props.children : null}
                    </div>
                </div>

                {this.props.children}
            </ExpandableContainer>
        )
    }

    marginLockChange(prop) {
        prop.value = !prop.value;
        //this.props.marginLock.value = !this.props.marginLock.value;
    }

    renderStepHorizontalField = (label, prop, renderField, addClass = true) => {
        if (prop.visible) {
            return (<StepHorizontalField label={label}>
                <div style={{ width: '100%' }} className={addClass ? 'field-input-with-unit-container' : null}>
                    <span className="input">{renderField(prop)}</span>
                </div>
            </StepHorizontalField>)
        }
        return <React.Fragment></React.Fragment>;
    }
    renderHeatExchangerRequirementsColumn = (side, isSecondary = false) => {
        return (
            <React.Fragment>
                {this.renderFluid(side, isSecondary)}
                {this.renderFlow(side)}
                {this.renderMaxPressureDrop(side)}
            </React.Fragment>
        )
    }

    renderFluid = (side, isSecondary) => {
        return (
            <StepHorizontalDoubleField label={side.fluid.label} className="heating-horizontal-field--black">
                <StepHorizontalDoubleFieldItem label={side.fluid.label}>
                    {isSecondary && this.props.model.circuitType.value === Configuration.CircuitType.Heating ?
                        <div className="field-input-with-unit-container">
                            <span className="input">{this.props.renderField(side.fluid)}</span>
                        </div> :
                        <span className="input">{__('Water')}</span>
                    }
                </StepHorizontalDoubleFieldItem>
                {!!side.mixRate && side.mixRate.visible &&
                    <StepHorizontalDoubleFieldItem label={side.mixRate.label}>
                        <div className="field-input-with-unit-container">
                            <span className="input">{this.props.renderField(side.mixRate)}</span>
                            <span className="unit">{side.mixRate.unit}</span>
                        </div>
                    </StepHorizontalDoubleFieldItem>
                }
            </StepHorizontalDoubleField>
        );
    }

    renderFlow = (side) => {
        return (
            <StepHorizontalField label={side.flow.label} className="heating-horizontal-field--black">
                <div className="field-input-with-unit-container">
                    <span className="input">{this.props.renderField(side.flow)}</span>
                    <span className="unit">{side.flow.unit}</span>
                </div>
            </StepHorizontalField>
        );
    }

    renderMaxPressureDrop = (side) => {
        return (
            <StepHorizontalField label={side.maxPressureDrop.label} className="heating-horizontal-field--black">
                <div className="field-input-with-unit-container">
                    <span className="input">{this.props.renderField(side.maxPressureDrop)}</span>
                    <span className="unit">{side.maxPressureDrop.unit}</span>
                </div>
            </StepHorizontalField>
        );
    }
}
